import axios from 'axios';

// Use relative URL for API calls - nginx will proxy /api to backend
const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
  getServices: () => api.get('/auth/services'),
  updateServices: (services) => api.put('/auth/services', { services }),
};

// Locations API
export const locationsAPI = {
  getAll: (slug = null, services = null) => {
    const params = new URLSearchParams();
    if (slug) params.append('slug', slug);
    if (services && services.length > 0) params.append('services', services.join(','));
    const queryString = params.toString();
    return api.get(`/locations${queryString ? `?${queryString}` : ''}`);
  },
  create: (data) => api.post('/locations', data),
  delete: (id) => api.delete(`/locations/${id}`),
  getMyLocation: () => api.get('/locations/my-location'),
  toggleStatus: (is_open) => api.put('/locations/status', { is_open }),
};

// Events API
export const eventsAPI = {
  getAll: (limit = 50, slug = null) => {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    if (slug) params.append('slug', slug);
    return api.get(`/events?${params.toString()}`);
  },
  create: (data) => api.post('/events', data),
  update: (id, data) => api.put(`/events/${id}`, data),
  delete: (id) => api.delete(`/events/${id}`),
  getMyEvents: () => api.get('/events/my-events'),
  cleanupExpired: () => api.post('/events/cleanup-expired'),
};

// Food truck API
export const truckAPI = {
  getBySlug: (slug) => api.get(`/auth/truck/${slug}`),
};

export default api;
